export const AFFILIATE = {
    REGISTER_AFFILIATE: 'affiliate/REGISTER_AFFILIATE', 
    CLEAR_MESSAGE: 'affiliate/CLEAR_MESSAGE' ,
    CREATE_SHORT_LINK: 'affiliate/CREATE_SHORT_LINK' ,
};

